import './styles.css';

export function UnifyAiLoader(props: React.ComponentProps<'svg'>) {
  return (
    <svg
      fill="none"
      height="100%"
      viewBox="0 0 24 24"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871 9.8428 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428 15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913 14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871 15.0162 8.24209 14.7342 7.50886L13 3Z"
        stroke="rgb(250, 247, 254)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        className="svg-elem-1"
        d="M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871 9.8428 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428 15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913 14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871 15.0162 8.24209 14.7342 7.50886L13 3Z"
        stroke="url(#paint0_linear_2042_13765)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <g className="rotate-group">
        <path
          d="M4.5 7V2"
          stroke="url(#paint1_linear_2042_13765)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M2 4.5H7"
          stroke="url(#paint2_linear_2042_13765)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
      <g className="rotate-group second-plus">
        <path
          d="M4.5 22V17"
          stroke="url(#paint3_linear_2042_13765)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M2 19.5H7"
          stroke="url(#paint4_linear_2042_13765)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_2042_13765"
          x1="2"
          x2="22.0001"
          y1="10.7218"
          y2="10.739"
        >
          <stop stopColor="#5F49E7" />
          <stop offset="1" stopColor="#F67979" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_2042_13765"
          x1="0.5"
          x2="13"
          y1="1.5"
          y2="19"
        >
          <stop stopColor="#5F49E7" />
          <stop offset="1" stopColor="#F67979" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_2042_13765"
          x1="4.25056e-08"
          x2="19.5"
          y1="4"
          y2="11"
        >
          <stop stopColor="#5F49E7" />
          <stop offset="1" stopColor="#F67979" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint3_linear_2042_13765"
          x1="0.5"
          x2="13"
          y1="16.5"
          y2="34"
        >
          <stop stopColor="#5F49E7" />
          <stop offset="1" stopColor="#F67979" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint4_linear_2042_13765"
          x1="4.25056e-08"
          x2="19.5"
          y1="19"
          y2="26"
        >
          <stop stopColor="#5F49E7" />
          <stop offset="1" stopColor="#F67979" />
        </linearGradient>
      </defs>
    </svg>
  );
}
